var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-main',{class:_vm.authShellClass}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }